/*
 * Resilia review slider — native scroll-snap carousel. Arrows step one card and wrap around; dots follow the scroll.
 */
(() => {
  const setup = (root) => {
    if (root.dataset.rsliderReady) return;
    root.dataset.rsliderReady = 'true';

    const track = root.querySelector('[data-rslider-track]');
    const dots = [...root.querySelectorAll('[data-rslider-dot]')];
    if (!track || !track.children.length) return;

    const step = () => track.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    const maxScroll = () => track.scrollWidth - track.clientWidth;
    const index = () => Math.round(track.scrollLeft / step());
    const lastIndex = () => Math.round(maxScroll() / step());

    const go = (i) => track.scrollTo({ left: i * step(), behavior: 'smooth' });

    root.querySelectorAll('[data-rslider-dir]').forEach((arrow) => {
      arrow.addEventListener('click', () => {
        const dir = Number(arrow.dataset.rsliderDir);
        const current = index();
        const last = lastIndex();
        if (dir > 0) go(current >= last ? 0 : current + 1);
        else go(current <= 0 ? last : current - 1);
      });
    });

    dots.forEach((dot, i) => dot.addEventListener('click', () => go(Math.min(i, lastIndex()))));

    let timer;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          // At the end, the last dot is active even when several cards are visible
          const active = track.scrollLeft >= maxScroll() - 2 ? dots.length - 1 : index();
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
        }, 80);
      },
      { passive: true }
    );
  };

  const init = () => document.querySelectorAll('[data-rslider]').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
})();
